export function getShipmentCosts() {
    return 6.95;
}